// extracted by mini-css-extract-plugin
var _1 = "LeaderboardsModal__backdrop--uxibV ModalGeneral__backdrop--gxZiG";
var _2 = "LeaderboardsModal__bg--bJEEl";
var _3 = "LeaderboardsModal__contents--s8dGx";
var _4 = "LeaderboardsModal__dropdown--jnx3q";
var _5 = "LeaderboardsModal__dropdownContainer--k6yzG";
var _6 = "LeaderboardsModal__errorContainer--TeZeZ";
var _7 = "LeaderboardsModal__leaderboardsIcon--O5O0J";
var _8 = "LeaderboardsModal__main--LhMKC";
var _9 = "LeaderboardsModal__metricHelpIcon--EWNSA";
var _a = "LeaderboardsModal__metricNavContainer--f50IM fontSize__leaderboardsModalMetric--m4QHj";
var _b = "LeaderboardsModal__metricText--FUSjL";
var _c = "LeaderboardsModal__title--Z9bYb fontSize__leaderboardsModalTitle--PBwFN";
export { _1 as "backdrop", _2 as "bg", _3 as "contents", _4 as "dropdown", _5 as "dropdownContainer", _6 as "errorContainer", _7 as "leaderboardsIcon", _8 as "main", _9 as "metricHelpIcon", _a as "metricNavContainer", _b as "metricText", _c as "title" }
